var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsName", $$v)
                      },
                      expression: "searchInfo.goodsName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.spuNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuNo", $$v)
                      },
                      expression: "searchInfo.spuNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类目名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.categoryName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "categoryName", $$v)
                      },
                      expression: "searchInfo.categoryName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增商品")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "", width: "100", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-image", {
                      staticClass: "goods-logo",
                      attrs: {
                        src: scope.row.goodsImg,
                        fit: "contain",
                        "preview-src-list": [scope.row.goodsImg]
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "商品信息", width: "400" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "table-goods-info" }, [
                      _c("div", { staticClass: "bairun-table-goods-name" }, [
                        _vm._v(_vm._s(scope.row.goodsName))
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(scope.row.goodsSpecification) +
                            "/" +
                            _vm._s(scope.row.goodsUnit)
                        )
                      ]),
                      _c("div", [_vm._v(_vm._s(scope.row.spuNo))])
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "销售指导价", prop: "goodsOfficialPrice" }
          }),
          _c("el-table-column", {
            attrs: { label: "类目", prop: "categoryName" }
          }),
          _c("el-table-column", {
            attrs: { label: "描述", prop: "goodsDesc" }
          }),
          _c("el-table-column", {
            attrs: { label: "赠送券", prop: "goodsTicket" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.goodsTicket !== ""
                      ? _c(
                          "div",
                          _vm._l(JSON.parse(scope.row.goodsTicket), function(
                            item
                          ) {
                            return _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(item.ticketName) +
                                  "*" +
                                  _vm._s(item.num) +
                                  "； "
                              )
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onDel(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _vm.addSPUDialogFormData.dialogVisible
        ? _c("AddSPUDialog", {
            ref: "AddSPUDialog",
            attrs: {
              addSPUDialogFormData: _vm.addSPUDialogFormData,
              hideItems: []
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }